import { userApi } from './api';

import { get, post } from '@/axiosConfig/index.js';

export default {
  UserInfo(params) {
    return get(userApi.UserInfo, params);
  },
  UserProfile(params) {
    return get(userApi.UserProfile, params);
  },
  unsubscribe(params) {
    return post(userApi.unsubscribe, params);
  },
  UserReglementationInfo(params) {
    return post(userApi.UserReglementationInfo, params);
  },
  UploadFile(formData) {
    return post(userApi.UploadFile, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  GetUploadedFile(params) {
    return get(userApi.GetUploadedFile, params);
  },
  SlackNotification(data) {
    return post(userApi.SlackNotification, data);
  },
  SaveReferralSource(data) {
    return post(userApi.SaveReferralSource, data);
  },
};
